
import { CricketBowlingBase } from './Cricket-Bowling-Base';

export const CricketBowlingHome = () => {
    return (<CricketBowlingBase 
                banner={<div className="row justify-content-center clearfix">
                          <div className="col-lg-9 col-12 text-center align-self-center">
                              <h2 style={{ fontSize: '32px', marginTop: '30px', marginBottom: '0px', color:"white", fontFamily: 'Comfortaa' }}>Real time bowling feedback</h2>
                              <h2 style={{ fontSize: '24px', marginTop: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>For real fast improvement</h2>
                          </div>
                          <div className="col-lg-3 col-11 text-center">
                                <img src="./assets/img/cricket/bowling/arm_angle_3.png" alt="Elbow angle" />
                          </div>
                      </div>}
                content={<section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ marginTop: "5px", marginBottom: "10px", color:"var(--thm-black)"}}>Slow-motion instant replays. <span style={{color:'yellowgreen'}}>After every bowl.</span></h2>
                              <p style={{ fontSize: "18px", margin: "15px 0 20px 0" }}><strong>Don't practice blindly.</strong> Watch, learn and improve after each delivery. All hands free.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-9 text-center">
                          <video controls loop width={"100%"} style={{marginTop: '20px'}} poster="./assets/img/cricket/bowling/arm_angle_3.png">
                                    <source src="/assets/img/cricket/bowling/bowling_video.mp4" type="video/mp4" />
                                </video>
                      </div>
                  </div>
              </div>
          </section>} />
    
    );
}

export default CricketBowlingHome;